module.exports = __webpack_public_path__ + "img/pic_shzp_pc.787b775a.jpg";